import { TipoSeguro } from "../TipoSeguro";
import { EnumValue } from "./enum-value";

export const TipoSeguroEnum = {
    veicular: 'VEICULAR',
    residencial: 'RESIDENCIAL',
    vida: 'VIDA',
    empresarial: 'EMPRESARIAL',
    celular: 'CELULAR',
}

export const TipoSeguroValues: EnumValue[] = [
    {
        codigo: TipoSeguroEnum.veicular,
        descricao: 'Veicular'
    },
    {
        codigo: TipoSeguroEnum.residencial,
        descricao: 'Residencial'
    },
    {
        codigo: TipoSeguroEnum.vida,
        descricao: 'Vida'
    },
    {
        codigo: TipoSeguroEnum.empresarial,
        descricao: 'Empresarial'
    },
    {
        codigo: TipoSeguroEnum.celular,
        descricao: 'Celular'
    }
]

export const getTipoSeguroLabel = (tipo: TipoSeguro): string => {
    const match = TipoSeguroValues.find(
      value => value.codigo === tipo
    );
    return match ? match.descricao : '';
  };

